const window = global.window || {
  location: { hostname: 'localhost' }
};

module.exports = {
  isProduction: window.location.host === 'www.balloonapp.de',
  isStaging: window.location.host === 'staging.balloonapp.de',
  isDevelopment: window.location.hostname !== 'www.balloonapp.de' && window.location.hostname !== 'staging.balloonapp.de'
};
